export default "__VITE_ASSET__ohf8jU_Q__"